// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container__PWOjx"};